export default {
  "seo.title": "Sobre nosotros | Bonvi",
  "seo.description": "Conoce a las personas, la experiencia y las disciplinas creativas que hay detrás de Bonvi.",
  "number.title": "Nuestras cifras",
  "number.copy": "Nuestro equipo trabaja en distintas disciplinas, lo que permite reunir la combinación adecuada de habilidades para cada proyecto.",
  "number.years": "Años de experiencia",
  "number.projects": "Proyectos entregados",
  "number.markets": "Mercados alcanzados",
  "strategy.title": "Nuestra estrategia",
  "strategy.copy": "Bonvi amplía la creatividad combinando operaciones impulsadas por IA con la diversa fuerza creativa del Sudeste Asiático, ofreciendo a las marcas ambiciosas mayor velocidad, profundidad cultural e impacto en el rendimiento sin el coste de crear un gran equipo interno.",
  "strategy.ariaLabel": "Nuestros principios estratégicos",
  "strategy.core.creative": "Crecimiento",
  "strategy.core.growthAt": "creativo",
  "strategy.core.scale": "a escala",
  "strategy.ai": "Motor creativo impulsado por IA",
  "strategy.sea": "Red de talento del Sudeste Asiático",
  "strategy.global": "Localización global",
  "strategy.embedded": "Equipos integrados",
  "strategy.human": "Dirección creativa humana",
  "strategy.performance": "Creatividad de rendimiento",
  "creative.title": "Nuestra creatividad",
  "creative.copy1": "Nuestro equipo trabaja en distintas disciplinas, lo que permite reunir la combinación adecuada de habilidades para cada proyecto.",
  "creative.copy2": "No creemos en una creatividad universal. Cada proyecto toma forma a partir de su audiencia, plataforma y propósito, combinando pensamiento estratégico con experimentación visual para crear trabajos distintivos, relevantes y concebidos para generar impacto.",
  "creative.ariaLabel": "Nuestros principios creativos",
  "creative.idea": "La idea primero",
  "creative.medium": "Creado para el medio",
  "creative.motion": "El movimiento está en nuestro ADN",
  "creative.performance": "Creatividad que funciona",
} as const;
